export const useAuthStatus = {
  UNKNOWN: 0,
  ANONYMOUS: 1,
  CONNECTED: 2,
  CONTROLLED: 3,
};

export function useAuthRedirect() {
  const authStore = useAuthStore();
  const tokenStore = useTokenStore();
  const sessionStorage = useSessionStorage();

  if (authStore.isConnected && !authStore.isControlled) {
    return navigateTo("/controle", { replace: true });
  }

  // There is a redirection url -----------------------------------------------------------------
  const out = sessionStorage.get("out");
  const redirect = sessionStorage.get("redirect");
  if (out) {
    sessionStorage.remove("out");

    // External redirect ------------------------------------------------------------------------
    sessionStorage.remove("origin");
    return navigateTo(
      {
        path: out,
        query: authStore.isControlled
          ? {
              access_token: tokenStore.access.token,
              access_expire: useTimestampToUnix(tokenStore.access.exp),
            }
          : null,
      },
      {
        replace: true,
        external: true,
      },
    );
  } else if (redirect) {
    sessionStorage.remove("redirect");
    // Internal redirect ------------------------------------------------------------------------
    return navigateTo(redirect, { replace: true });
  }

  const from = useRoute();
  const redirectRoute = useRouteValidation(from);
  // Default redirection  -----------------------------------------------------------------------
  if (redirectRoute) {
    return navigateTo(redirectRoute, { replace: true });
  }

  // Redirection not necessary --------------------------------------------------------
  return false;
}

export async function useLogout(error = false) {
  const fetchApi = useFetchApi();
  const sessionStorage = useSessionStorage();
  const localStorage = useLocalStorage();

  if (!error) {
    await fetchApi
      .delete("/v1/logout")
      .then(() => true)
      .catch(
        (e) =>
          e.status !== 401 &&
          (e.status !== 403 || e.data.error !== "user_state"),
      );
  }

  const authStore = useAuthStore();
  const eventStore = useEventStore();
  const editStore = useEditStore();
  const tokenStore = useTokenStore();

  const fetchPay = useFetchPay();

  authStore.reset();
  eventStore.reset();
  editStore.reset();

  fetchApi.resetAccess();
  sessionStorage.remove("access");
  fetchApi.resetRefresh();
  localStorage.remove("refresh");
  fetchPay.resetAccess();
  fetchPay.resetRefresh();

  tokenStore.resetAccess();

  sessionStorage.remove("out");
  sessionStorage.remove("redirect");

  if (!error) {
    const origin = sessionStorage.get("origin");
    if (origin) {
      sessionStorage.remove("origin");

      // Rustine Agendaweb wrong currentUrl
      const input = new URL(origin.url);
      input.searchParams.delete("access_token");
      input.searchParams.delete("access_expire");

      return navigateTo(input.href, {
        replace: true,
        external: origin.external,
      }).finally(() => clearNuxtData());
    }
  }
  sessionStorage.remove("origin");

  const route = useRoute();
  const { CONNECTED } = useAuthStatus;
  if (route.meta.auth && route.meta.auth >= CONNECTED) {
    return navigateTo("/authentification", { replace: true }).finally(() =>
      clearNuxtData(),
    );
  }

  clearNuxtData();
  return true;
}

export function useSetToken(data) {
  const timestamp = Date.now();
  const fetchApi = useFetchApi();
  const fetchPay = useFetchPay();

  const sessionStorage = useSessionStorage();
  const localStorage = useLocalStorage();

  const authStore = useAuthStore();
  const tokenStore = useTokenStore();

  authStore.set(data);

  // Helpers http
  fetchApi.accessStore = {
    token: data.accessToken,
    delay: data.accessExpiresIn * 1000,
    exp: timestamp + data.accessExpiresIn * 1000,
  };

  if (data.refreshToken) {
    fetchApi.refreshStore = {
      token: data.refreshToken,
      delay: data.refreshExpiresIn * 1000,
      exp: timestamp + data.refreshExpiresIn * 1000,
    };
  }

  fetchPay.config.connected = true;

  // Browser storage
  sessionStorage.set("access", fetchApi.accessStore);
  localStorage.set("refresh", fetchApi.refreshStore);

  // Reactive store
  tokenStore.access = fetchApi.accessStore;
}
